module.exports = __webpack_public_path__ + "img/国际博物馆日.7afae124.png";